import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import { TopEventsEventSportSection } from 'src/main/cms/TopEvents/topEventsList/topEventsEventsSections/TopEventsSections';
import { TopEventsEventCompetitionSectionWrapper } from 'src/main/cms/TopEvents/topEventsList/topEventsEventsSections/TopEventsCompetitionSectionWrapper';
import { List as MovableList } from 'react-movable';
import { ListContentWrapper } from 'src/domains/layouts/shared/cms/list/List.style';
import { Response200Type } from 'src/api_openapi/generated/openapi_website_cms_getAllTopEventsSports';
import { TopEventsCompetitionsListState } from 'src/main/cms/TopEvents/topEventsList/topEventsEventsSections/TopEventsSportSectionWrapper.state';

export type TopEventsSportDataModelType = Response200Type[number];

interface PropsType {
    sportData: TopEventsSportDataModelType;
    isDragged: boolean;
}

export const TopEventsEventSportSectionWrapper = observer(
    'TopEventsEventSportSectionWrapper',
    ({ sportData, isDragged }: PropsType) => {
        const {
            cmsState: { topEventsState },
            sdkStaff,
            trpcClient,
        } = useAppStateContext();
        const topEventsEventSportState = topEventsState.getTopEventsEventSportStateBySportSlug(sportData.sport_id);
        const sortedCompetitionsData = sportData.competitions_list;
        const [topEventsCompetitionsListState] = useState(
            () => new TopEventsCompetitionsListState(sdkStaff, trpcClient, topEventsState, sportData)
        );

        const { sportName, handleCompetitionOrder } = topEventsCompetitionsListState;

        if (topEventsCompetitionsListState.isAnyCompetitions === false) {
            return null;
        }

        return (
            <>
                <TopEventsEventSportSection
                    key={sportData.id}
                    label={sportName}
                    isOpen={topEventsEventSportState.isOpenSection}
                    isDragged={isDragged}
                    topEventsEventSportState={topEventsEventSportState}
                    dataTest={`topEvents-event-sport-${sportName.toLowerCase().replaceAll(' ', '')}`}
                />
                {topEventsEventSportState.isOpenSection === false ? null : (
                    <MovableList
                        values={sortedCompetitionsData}
                        onChange={handleCompetitionOrder}
                        renderList={({ children, props, isDragged }): React.ReactNode => (
                            <ListContentWrapper
                                {...props}
                                isDragged={isDragged}
                            >
                                {children}
                            </ListContentWrapper>
                        )}
                        renderItem={({ value, props, isDragged }): JSX.Element | null => {
                            return (
                                <div
                                    {...props}
                                    style={{ ...props.style, zIndex: 'initial' }}
                                >
                                    <TopEventsEventCompetitionSectionWrapper
                                        key={value.id}
                                        sportId={sportData.sport_id}
                                        competitionData={value}
                                        isDragged={isDragged}
                                        topEventsEventSportState={topEventsEventSportState}
                                    />
                                </div>
                            );
                        }}
                    />
                )}
            </>
        );
    }
);
